import React, { useState, useEffect } from 'react';
import bannerImage from 'AppSrc/core/components/mycrq-home-screen/home-screen-banner.jpg';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/help/help.scss';
import { BackAndRefresh } from '../utility/back-refresh';
import { FeedBack } from './feedback';
import responseData from './help-data.json';

// Svg Component For Fixed CRQ PDF link
const FixedAvatar = () => (
  <svg width="40" height="40" fill="currentColor" className="avatar-fixed" viewBox="0 0 16 16">
    <path d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z" />
  </svg>
);

// Svg Component For Mobile CRQ PDF link
const MobileAvatar = () => (
  <svg width="40" height="40" fill="currentColor" className="avatar-mobile" viewBox="0 0 16 16">
    <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
    <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
  </svg>
);

// Svg Component For FAQs PDF link
const HelpAvatar = () => (
  <svg width="40" height="40" fill="currentColor" className="avatar-FAQ" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
  </svg>
);

// Svg component for Search bar
const HelpSearchAvatar = () => (
  <svg
    viewBox="0 0 1024 1024"
    fill="currentColor"
    height="1em"
    width="1em"
  >
    <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" />
  </svg>
);
// close
const CloseAvatar = () => (
  <svg
    viewBox="0 0 21 21"
    fill="currentColor"
    height="1em"
    width="1em"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15.5 15.5l-10-10zM15.5 5.5l-10 10" />
    </g>
  </svg>
);

const HelpSearchBar = () => {
  const [search, setSearch] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [searchResultData, setSearchResultData] = useState(null);
  const [isSearchListVisible, setIsSearchListVisible] = useState(true);

  const handleChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value === '') {
      setIsSearchListVisible(true);
      setSearchResultData(null);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowUp' && selectedItem > 0) {
      setSelectedItem((prev) => prev - 1);
    }
    else if (e.key === 'ArrowDown' && selectedItem < searchData.length - 1) {
      setSelectedItem((prev) => prev + 1);
    }
    else if (e.key === 'Enter' && selectedItem >= 0) {
      setSearchResultData(searchData[selectedItem]);
      setIsSearchListVisible(false);
    }
  };

  const clearSearch = () => {
    setSearch('');
    setSearchResultData(null);
    setIsSearchListVisible(true);
  };

  useEffect(() => {
    if (search !== '') {
      const filterData = responseData.filter((data) => {
        const newFilteredData = data.values.toLowerCase();
        return newFilteredData.includes(search.toLowerCase());
      });
      setSearchData(filterData);
    }
    else {
      setSearchData([]);
    }
  }, [search]);

  const getHighlightedText = (text) => {
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b${escapedSearch}`, 'gi');
    const parts = text.split(/\b/);

    return (
      <span>
        {parts.map((part) => (
          <span className={regex.test(part) ? 'highlight' : ''}>
            {part}
          </span>
        ))}
      </span>
    );
  };

  return (
    <div className="help-search-bar">
      <HelpSearchAvatar />
      <input
        className="help-search-input-type"
        type="text"
        placeholder="Search everything about ACE"
        onChange={handleChange}
        value={search}
        onKeyDown={handleKeyDown}
      />
      {isSearchListVisible && (
        <div className="help-search-result">
          {searchData.map((data, index) => {
            const resultData = data.values;
            const truncatedData = `${resultData.substring(0, 200)}...`;

            return (
              <button
                type="button"
                href="#"
                className={selectedItem === index ? 'help_search_suggestion_line active' : 'help_search_suggestion_line'}
                onClick={() => {
                  setSearchResultData(data);
                  setIsSearchListVisible(false);
                }}
              >
                {getHighlightedText(`${truncatedData}`, search)}
              </button>
            );
          })}
        </div>
      )}
      {searchResultData && (
        <div className="help-search-result-details">
          <p className="help-searched-result">Searched result</p>
          {searchResultData.values}
        </div>
      )}
      <button type="button" className="help-cross-wrapper" onClick={clearSearch}>
        <CloseAvatar />
      </button>
    </div>
  );
};

const Help = React.memo(() => (
  <div className="page-content-container page-content-container-home">
    <BackAndRefresh />
    <div className="page-content">
      <div
        className="home-screen-banner"
        style={{ backgroundImage: `url(${bannerImage})` }}
      />
      <p className="help-text">Help Center</p>
      <div
        className="pdf-wrapper"
      >
        <a href="https://vodafone.sharepoint.com/:b:/r/sites/ACEKnowledgeCenter/Shared%20Documents/General/Fixed_CoOrdinator_ACE_v1.2.pdf?csf=1&web=1&e=m8JrkU" target="_blank" rel="noopener noreferrer">
          <FixedAvatar />
          <p>Fixed CRQ</p>
        </a>
        <a href="https://vodafone.sharepoint.com/:b:/r/sites/ACEKnowledgeCenter/Shared%20Documents/General/Mobile_CoOrdinator_ACE_v1.2.pdf?csf=1&web=1&e=PcYObw" target="_blank" rel="noopener noreferrer">
          <MobileAvatar />
          <p>Mobile CRQ</p>
        </a>
        <a href="https://eur03.safelinks.protection.outlook.com/ap/x-59584e83/?url=https%3A%2F%2Fvodafone.sharepoint.com%2F%3Ax%3A%2Fr%2Fsites%2FACEKnowledgeCenter%2FShared%2520Documents%2FGeneral%2FKnown%2520Issues%2520FAQ%2520020321.xlsx%3Fd%3Dw48191d17c35849f7ad8abdfa2cd3a4ec%26csf%3D1%26web%3D1%26e%3DoSw7VK&data=05%7C01%7Cadiba.athani2%40vodafone.com%7C674e738b3ac2476e238208db3f427d6c%7C68283f3b84874c86adb3a5228f18b893%7C0%7C0%7C638173327032748389%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=Qs%2BurvHi2%2FixBmOE0uRy6nIkzTTgljvVBFxsx9zvCNM%3D&reserved=0" target="_blank" rel="noopener noreferrer">
          <HelpAvatar />
          <p>FAQs</p>
        </a>
        <FeedBack />
      </div>
      <HelpSearchBar />
    </div>
  </div>
));

export {
  HelpSearchBar,
  Help,
};
